import { render, staticRenderFns } from "./SubActionsComponent.vue?vue&type=template&id=5b44c1d0"
import script from "./SubActionsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubActionsComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SubActionsComponent.vue?vue&type=style&index=0&id=5b44c1d0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b44c1d0')) {
      api.createRecord('5b44c1d0', component.options)
    } else {
      api.reload('5b44c1d0', component.options)
    }
    module.hot.accept("./SubActionsComponent.vue?vue&type=template&id=5b44c1d0", function () {
      api.rerender('5b44c1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/actions/SubActions/SubActionsComponent.vue"
export default component.exports